export const NUM_DECIMALS_ROUND_WALL_EDIT = 2

/**
 * Block id registered by `WallEdit` while a wall is actively being moved/extended. Subscribers (e.g.
 * the IFC import planar selection) refuse element selection while it is set, so the click that ends
 * a move/extend doesn't select whatever wall the endpoint landed on.
 */
export const WALL_EDIT_IN_PROGRESS_BLOCK = 'wall-edit-in-progress'
